import * as m from '~/paraglide/messages'
import { Card, CardContent } from '~/shared/ui/card'
import { PageHeader } from '~/widgets/page-header'
import { FlyerGenerator } from './flyer-generator'

export function FlyerTool() {
  return (
    <div className="space-y-6">
      <PageHeader title={m.flyerTool()} description={m.flyerToolPageDescription()} />
      <Card>
        <CardContent className="pt-6">
          <FlyerGenerator />
        </CardContent>
      </Card>
    </div>
  )
}
